import { useEffect, useRef } from 'react';
import { useTheme } from 'styled-components';
import useResetPasswordController from '../../1_application/auth/resetPasswordController';
import BoxContainer from '../core/components/box/boxContainer';
import Column from '../core/components/box/column';
import SizedBox from '../core/components/box/sizedBox';
import LXLargeButton from '../core/components/buttons/lxLargeButton';
import { XCenter } from '../core/components/center';
import LXInput from '../core/texts/lxInput';
import { LXh2, LXh5 } from '../core/texts/lxText';

const ChangePasswordPage = () => {
  const theme = useTheme();
  const {
    handleCurrentPaswordInput,
    handleConfirmPasswordInput,
    handleNewPasswordInput,
    validationConfirmPassword,
    onValidateConfirmPassword,
    onTryChangePassword,
    newPassword,
    confirmPassword,
    currentPassword,
  } = useResetPasswordController();
  const buttonRef = useRef<HTMLButtonElement>(null);

  const confirmValidation = async (
    confirmPassword: Password
  ): Promise<string> => {
    if (newPassword !== confirmPassword) return theme.texts.passwordsDoNotMatch;
    return '';
  };

  useEffect(() => {
    const handleEnter = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && buttonRef.current) buttonRef.current.click();
    };
    window.addEventListener('keydown', handleEnter);
    return () => window.removeEventListener('keydown', handleEnter);
  }, []);

  return (
    <XCenter>
      <Column>
        <SizedBox height={80}></SizedBox>
        <LXh2>{theme.texts.changePassword}</LXh2>
        <SizedBox height={37}></SizedBox>
        <BoxContainer padding="120px 320px">
          <Column>
            <LXh5>{theme.texts.currentPassword}</LXh5>
            <SizedBox height={8}></SizedBox>
            <LXInput
              tabIndex={1}
              type="password"
              value={currentPassword}
              onChange={handleCurrentPaswordInput}
              width={320}
              placeholder={theme.texts.enterCurrentPassword}
            ></LXInput>
            <SizedBox height={16}></SizedBox>
            <LXh5>{theme.texts.newPassword}</LXh5>
            <SizedBox height={8}></SizedBox>
            <LXInput
              tabIndex={2}
              type="password"
              value={newPassword}
              onChange={handleNewPasswordInput}
              width={320}
              placeholder={theme.texts.enterNewPassword}
            ></LXInput>
            <SizedBox height={16}></SizedBox>
            <LXh5>{theme.texts.confirmPasword}</LXh5>
            <SizedBox height={8}></SizedBox>
            <LXInput
              tabIndex={3}
              type="password"
              value={confirmPassword}
              validate={confirmValidation}
              onValidate={onValidateConfirmPassword}
              onChange={handleConfirmPasswordInput}
              width={320}
              placeholder={theme.texts.reEnterPassword}
            ></LXInput>
            <SizedBox height={40}></SizedBox>
            <LXLargeButton
              tabIndex={4}
              disabled={validationConfirmPassword}
              onClick={onTryChangePassword}
            >
              {theme.texts.changePassword}
            </LXLargeButton>
          </Column>
        </BoxContainer>
      </Column>
    </XCenter>
  );
};

export default ChangePasswordPage;
